import * as pagesActions from "./pages";
export const pages = pagesActions;

import * as boardsActions from "./boards";
export const boards = boardsActions;

import * as historyActions from "./history";
export const history = historyActions;

import * as componentsActions from "./components";
export const components = componentsActions;

import * as productsActions from "./products";
export const products = productsActions;

export * from "./whiteboard";
